import React from "react";
import { Link } from "@skbkontur/react-ui";

import { pluralize } from "../../../../../Helpers/StringHelpers";
import {
    CandyPopdProtocolState,
    PopdResultCode,
} from "../../../../../../../Common/CandyApiClient/Types/ErrorLog/CandyPopdProtocol";

import { PopdProtocolItem } from "./PopdProtocol.styles";

interface PopdProtocolErrorsProps {
    protocol?: CandyPopdProtocolState;
    hasInternalErrors: boolean;
    isSuccessful: boolean;
    canRunCheck: boolean;
}

export const PopdProtocolErrorText = (props: PopdProtocolErrorsProps) => {
    if (props.isSuccessful) {
        return <div>Ошибок и предупреждений нет.</div>;
    }

    if (props.canRunCheck) {
        return <div>Перед отправкой запустите проверки в&nbsp;СФР и&nbsp;убедитесь, что ошибок нет.</div>;
    }

    if (props.hasInternalErrors) {
        return <div>Можно запустить проверки в&nbsp;СФР после исправления ошибок в&nbsp;форме.</div>;
    }

    if (!props.protocol) {
        return null;
    }

    const errorText: Record<PopdResultCode, React.ReactElement> = {
        [PopdResultCode.Ok]: (
            <div>
                {props.protocol.errorsCount != undefined && props.protocol.errorsCount > 0 && (
                    <PopdProtocolItem data-tid="errors-count">
                        {pluralize(props.protocol.errorsCount, ["ошибка", "ошибки", "ошибок"])}
                    </PopdProtocolItem>
                )}
                {props.protocol.warningsCount != undefined && props.protocol.warningsCount > 0 && (
                    <PopdProtocolItem data-tid="warnings-count">
                        {pluralize(props.protocol.warningsCount, [
                            "предупреждение",
                            "предупреждения",
                            "предупреждений",
                        ])}
                    </PopdProtocolItem>
                )}
            </div>
        ),
        [PopdResultCode.Error]: (
            <div>
                {props.protocol.message ?? "Не удалось получить протокол, что-то пошло не так"}. Скачайте файл отчета
                и&nbsp;проверьте его в&nbsp;программе{" "}
                <Link
                    href={"https://sfr.gov.ru/employers/general_information/software/software/"}
                    target={"_blank"}
                    rel={"noreferrer"}>
                    ПО ПД от&nbsp;СФР
                </Link>
                .
            </div>
        ),
    };

    return props.protocol.resultCode ? errorText[props.protocol.resultCode] : null;
};
